import router from "@/router";
import { axiosInstance } from "@/plugins/axios";
import { getAuth, signOut } from "firebase/auth";

export default {
  namespaced: true,
  state: {
    user: {},
  },
  getters: {
    user(state) {
      return state.user;
    },
  },
  mutations: {
    SET_USER(state, value) {
      state.user = value;
    },
  },
  actions: {
    async fetchUser(context, value) {
      if (!value) {
        context.dispatch("setUser", null);
        context.dispatch("setIsLoading", false, { root: true });
        return;
      }

      let user = {};
      user.uid_google = value.uid;
      user.name = value.displayName;
      user.email = value.email;
      user.token = value.refreshToken;

      context.dispatch("registerUserBD", user);
    },
    async registerUserBD(context, value) {
      await axiosInstance({
        method: "POST",
        url: "signup",
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("signin", value);
        });
    },
    async signin(context, value) {
      const { data } = await axiosInstance({
        method: "POST",
        url: "signin",
        data: value,
      });

      if (data.token && router.currentRoute.name !== "Welcome") {
        context.dispatch("setUser", data);
        router.push({ name: "Welcome" });
      }
    },
    async signOutUser(context) {
      context.dispatch("setIsLoading", true, { root: true });
      const auth = getAuth();

      await signOut(auth)
        .then(() => {
          context.dispatch("setIsLoading", false, { root: true });
          router.push({ name: "Login" });
        })
        .catch((error) => {
          context.dispatch("setIsLoading", false, { root: true });
          this.$swal.fire({
            icon: "error",
            html: error,
          });
        });
    },
    setUser(context, value) {
      context.commit("SET_USER", value);
    },
  },
};
